<template>
  <v-container fluid class="pa-3 pa-sm-6">
    <v-row justify="start">
      <v-col cols="12" sm="12" md="10" lg="12" xl="6">
        <!-- Header -->
        <v-card elevation="6" class="rounded-xl pa-3 pa-sm-4">
          <v-card-title
            class="d-flex align-center justify-space-between flex-wrap ga-2"
          >
            <div class="d-flex align-center">
              <v-icon
                icon="mdi-shield-account"
                color="indigo-darken-4"
                class="mr-2"
              ></v-icon>
              <span
                class="text-subtitle-1 text-sm-h6 font-weight-bold text-indigo-darken-4"
              >
                ชมรมศิษย์เก่า NPTU
              </span>
            </div>
            <v-btn
              :color="isEditing ? 'grey-darken-2' : 'indigo-darken-4'"
              :prepend-icon="isEditing ? 'mdi-close' : 'mdi-account-edit'"
              variant="tonal"
              size="small"
              @click="toggleEdit"
            >
              {{ isEditing ? "ยกเลิก" : "แก้ไขข้อมูล" }}
            </v-btn>
          </v-card-title>

          <v-divider class="my-2 my-sm-3"></v-divider>

          <v-card-subtitle class="d-flex align-center flex-wrap ga-2 pb-1">
            <span class="text-grey-darken-1 mr-1">สถานะ:</span>
            <v-chip
              :color="statusColor(authStore.user?.status)"
              variant="flat"
              size="small"
            >
              {{ authStore.user?.status || "-" }}
            </v-chip>
            <v-spacer></v-spacer>
            <span class="text-caption font-weight-bold">
              รหัสนักศึกษา: {{ authStore.user?.studentNum }}
            </span>
          </v-card-subtitle>
        </v-card>

        <!-- VIEW MODE -->
        <v-card
          v-if="!isEditing"
          elevation="4"
          class="rounded-xl pa-2 pa-sm-4 mt-3 mt-sm-4"
        >
          <v-card-text class="pa-2 pa-sm-4">
            <div class="text-subtitle-2 text-grey-darken-1 mb-3">
              ข้อมูลส่วนตัว
            </div>
            <v-row dense>
              <v-col cols="5" class="text-grey-darken-1 text-body-2"
                >ชื่อ</v-col
              >
              <v-col cols="7" class="font-weight-medium text-body-2">{{
                authStore.user?.firstname || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >นามสกุล</v-col
              >
              <v-col cols="7" class="font-weight-medium text-body-2 mt-2">{{
                authStore.user?.lastname || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >อีเมล</v-col
              >
              <v-col
                cols="7"
                class="text-body-2 mt-2"
                style="word-break: break-all"
                >{{ authStore.user?.email || "-" }}</v-col
              >

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >Line ID</v-col
              >
              <v-col cols="7" class="text-body-2 mt-2">{{
                authStore.user?.LineId || "-"
              }}</v-col>
            </v-row>

            <v-divider class="my-3 my-sm-4"></v-divider>
            <div class="text-subtitle-2 text-grey-darken-1 mb-3">ที่อยู่</div>
            <v-row dense>
              <v-col cols="5" class="text-grey-darken-1 text-body-2"
                >ที่อยู่</v-col
              >
              <v-col cols="7" class="text-body-2">{{
                authStore.user?.address || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >จังหวัด</v-col
              >
              <v-col cols="7" class="text-body-2 mt-2">{{
                authStore.user?.province || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >อำเภอ/เขต</v-col
              >
              <v-col cols="7" class="text-body-2 mt-2">{{
                authStore.user?.district || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >ตำบล/แขวง</v-col
              >
              <v-col cols="7" class="text-body-2 mt-2">{{
                authStore.user?.subDistrict || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >รหัสไปรษณีย์</v-col
              >
              <v-col cols="7" class="text-body-2 mt-2">{{
                authStore.user?.zipCode || "-"
              }}</v-col>
            </v-row>

            <v-divider class="my-3 my-sm-4"></v-divider>
            <div class="text-subtitle-2 text-grey-darken-1 mb-3">
              ข้อมูลการทำงาน
            </div>
            <v-row dense>
              <v-col cols="5" class="text-grey-darken-1 text-body-2"
                >ชื่อที่ทำงาน</v-col
              >
              <v-col cols="7" class="text-body-2">{{
                authStore.user?.jobName || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >เบอร์โทรที่ทำงาน</v-col
              >
              <v-col cols="7" class="text-body-2 mt-2">{{
                authStore.user?.jobPhone || "-"
              }}</v-col>

              <v-col cols="5" class="text-grey-darken-1 text-body-2 mt-2"
                >ที่อยู่ที่ทำงาน</v-col
              >
              <v-col cols="7" class="text-body-2 mt-2">{{
                authStore.user?.jobAddress || "-"
              }}</v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="px-2 px-sm-4 pb-3">
            <v-btn
              variant="text"
              color="grey-darken-2"
              prepend-icon="mdi-logout"
              @click="handleLogout()"
            >
              ออกจากระบบ
            </v-btn>
          </v-card-actions>
        </v-card>

        <!-- EDIT MODE -->
        <v-card
          v-else
          elevation="4"
          class="rounded-xl pa-2 pa-sm-4 mt-3 mt-sm-4"
        >
          <v-card-text class="pa-2 pa-sm-4">
            <v-form ref="formRef" @submit.prevent="handleSubmit">
              <div class="text-subtitle-2 text-grey-darken-1 mb-2">
                ข้อมูลส่วนตัว
              </div>

              <v-text-field
                v-model="form.firstname"
                label="ชื่อ"
                prepend-inner-icon="mdi-account"
                variant="outlined"
                density="comfortable"
                :rules="[(v) => !!v || 'กรุณากรอกชื่อ']"
                class="mb-2"
              />
              <v-text-field
                v-model="form.lastname"
                label="นามสกุล"
                prepend-inner-icon="mdi-account"
                variant="outlined"
                density="comfortable"
                :rules="[(v) => !!v || 'กรุณากรอกนามสกุล']"
                class="mb-2"
              />
              <v-text-field
                v-model="form.email"
                label="อีเมล"
                prepend-inner-icon="mdi-email"
                variant="outlined"
                density="comfortable"
                type="email"
                inputmode="email"
                autocomplete="email"
                :rules="[
                  (v) => !!v || 'กรุณากรอกอีเมล',
                  (v) => /.+@.+\..+/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง',
                ]"
                class="mb-2"
              />
              <v-text-field
                v-model="form.LineId"
                label="Line ID"
                prepend-inner-icon="mdi-chat"
                variant="outlined"
                density="comfortable"
                class="mb-2"
              />

              <v-divider class="my-3 my-sm-4"></v-divider>
              <div class="text-subtitle-2 text-grey-darken-1 mb-2">
                เปลี่ยนรหัสผ่าน (เบอร์โทรศัพท์)
              </div>

              <v-text-field
                v-model="form.currentPhone"
                label="เบอร์โทรปัจจุบัน (รหัสผ่านเดิม)"
                prepend-inner-icon="mdi-phone-lock"
                variant="outlined"
                density="comfortable"
                type="tel"
                inputmode="tel"
                autocomplete="tel"
                class="mb-2"
              />
              <v-text-field
                v-model="form.newPhone"
                label="เบอร์โทรใหม่ (รหัสผ่านใหม่)"
                prepend-inner-icon="mdi-phone-plus"
                variant="outlined"
                density="comfortable"
                type="tel"
                inputmode="tel"
                :rules="[
                  (v) => !v || v.length === 10 || 'เบอร์โทรต้องมี 10 หลัก',
                ]"
                class="mb-2"
              />

              <v-divider class="my-3 my-sm-4"></v-divider>
              <div class="text-subtitle-2 text-grey-darken-1 mb-2">ที่อยู่</div>

              <v-text-field
                v-model="form.address"
                label="ที่อยู่"
                prepend-inner-icon="mdi-home"
                variant="outlined"
                density="comfortable"
                class="mb-2"
              />

              <!-- On mobile all cols full width, on md+ split into 2 -->
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="form.province"
                    label="จังหวัด"
                    prepend-inner-icon="mdi-map-marker"
                    variant="outlined"
                    density="comfortable"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="form.district"
                    label="อำเภอ/เขต"
                    prepend-inner-icon="mdi-map-marker-outline"
                    variant="outlined"
                    density="comfortable"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="form.subDistrict"
                    label="ตำบล/แขวง"
                    prepend-inner-icon="mdi-map-marker-radius"
                    variant="outlined"
                    density="comfortable"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="form.zipCode"
                    label="รหัสไปรษณีย์"
                    prepend-inner-icon="mdi-mailbox"
                    variant="outlined"
                    density="comfortable"
                    inputmode="numeric"
                    type="number"
                    :rules="[
                      (v) =>
                        !v ||
                        String(v).length === 5 ||
                        'รหัสไปรษณีย์ต้องมี 5 หลัก',
                    ]"
                  />
                </v-col>
              </v-row>

              <v-divider class="my-3 my-sm-4"></v-divider>
              <div class="text-subtitle-2 text-grey-darken-1 mb-2">
                ข้อมูลการทำงาน
              </div>

              <v-text-field
                v-model="form.jobName"
                label="ชื่อที่ทำงาน"
                prepend-inner-icon="mdi-briefcase"
                variant="outlined"
                density="comfortable"
                class="mb-2"
              />
              <v-text-field
                v-model="form.jobPhone"
                label="เบอร์โทรที่ทำงาน"
                prepend-inner-icon="mdi-phone-classic"
                variant="outlined"
                density="comfortable"
                type="tel"
                inputmode="tel"
                class="mb-2"
              />
              <v-text-field
                v-model="form.jobAddress"
                label="ที่อยู่ที่ทำงาน"
                prepend-inner-icon="mdi-office-building"
                variant="outlined"
                density="comfortable"
                class="mb-2"
              />

              <v-divider class="my-3 my-sm-4"></v-divider>

              <!-- Stacked buttons on mobile, side by side on sm+ -->
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-btn
                    block
                    color="indigo-darken-4"
                    size="large"
                    type="submit"
                    :loading="isLoading"
                    prepend-icon="mdi-content-save"
                    class="mb-2 mb-sm-0"
                  >
                    บันทึกข้อมูล
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                    block
                    variant="outlined"
                    color="grey-darken-2"
                    size="large"
                    prepend-icon="mdi-refresh"
                    @click="resetForm"
                  >
                    รีเซ็ต
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup>
import { ref, reactive, getCurrentInstance, onMounted, watch } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router";

import axios from "axios";

const { proxy } = getCurrentInstance();
const authStore = useAuthStore();
const router = useRouter();
const formRef = ref(null);
const isLoading = ref(false);
const isEditing = ref(false);

const form = reactive({
  firstname: "",
  lastname: "",
  email: "",
  LineId: "",
  address: "",
  province: "",
  district: "",
  subDistrict: "",
  zipCode: "",
  jobName: "",
  jobPhone: "",
  jobAddress: "",
  currentPhone: "",
  newPhone: "",
});

const populateForm = () => {
  const u = authStore.user;
  if (!u?.studentNum) return; // ✅ don't populate if user data isn't ready yet
  form.firstname = u.firstname || "";
  form.lastname = u.lastname || "";
  form.email = u.email || "";
  form.LineId = u.LineId || "";
  form.address = u.address || "";
  form.province = u.province || "";
  form.district = u.district || "";
  form.subDistrict = u.subDistrict || "";
  form.zipCode = u.zipCode || "";
  form.jobName = u.jobName || "";
  form.jobPhone = u.jobPhone || "";
  form.jobAddress = u.jobAddress || "";
  form.currentPhone = "";
  form.newPhone = "";
};
onMounted(populateForm);
watch(
  () => authStore.user,
  (newUser) => {
    if (newUser && newUser.studentNum) {
      populateForm();
    }
  },
  { deep: true, immediate: true },
);
const toggleEdit = () => {
  isEditing.value = !isEditing.value;
  if (isEditing.value) populateForm(); // reset form to current data when opening edit
};

const resetForm = () => populateForm();

const statusColor = (status) => {
  if (!status) return "grey";
  const s = status.toLowerCase();
  if (s.includes("approve")) return "success";
  if (s.includes("reject")) return "error";
  return "warning";
};

const handleSubmit = async () => {
  const { valid } = await formRef.value.validate();
  if (!valid) return;

  if (form.newPhone && !form.currentPhone) {
    proxy.$swal({ icon: "warning", title: "กรุณากรอกเบอร์โทรปัจจุบันด้วย" });
    return;
  }

  isLoading.value = true;
  try {
    const payload = {
      studentNum: authStore.user.studentNum,
      firstname: form.firstname,
      lastname: form.lastname,
      email: form.email,
      LineId: form.LineId,
      address: form.address,
      province: form.province,
      district: form.district,
      subDistrict: form.subDistrict,
      zipCode: form.zipCode,
      jobName: form.jobName,
      jobPhone: form.jobPhone,
      jobAddress: form.jobAddress,
      ...(form.newPhone && {
        currentPhone: form.currentPhone,
        newPhone: form.newPhone,
      }),
    };

    await axios.post("/api/alumni-edit", { payload: payload });

    // Update store
    Object.assign(authStore.user, {
      firstname: form.firstname,
      lastname: form.lastname,
      email: form.email,
      LineId: form.LineId,
      address: form.address,
      province: form.province,
      district: form.district,
      subDistrict: form.subDistrict,
      zipCode: form.zipCode,
      jobName: form.jobName,
      jobPhone: form.jobPhone,
      jobAddress: form.jobAddress,
    });
    authStore.displayName = `${form.firstname} ${form.lastname}`;

    isEditing.value = false;

    proxy.$swal({
      icon: "success",
      title: "บันทึกข้อมูลสำเร็จ",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
    });
  } catch (error) {
    proxy.$swal({
      icon: "error",
      title: "เกิดข้อผิดพลาด",
      text: error.response?.data?.error || "ไม่สามารถบันทึกข้อมูลได้",
      confirmButtonColor: "#d33",
    });
  } finally {
    isLoading.value = false;
  }
};

const handleLogout = async () => {
  const result = await proxy.$swal({
    title: "Are you sure?",
    text: "You will be logged out of your account.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, log me out!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      await authStore.logout();
      await proxy.$swal({
        title: "Logged Out!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      router.push("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  }
};
</script>
